import * as React from 'react';


var Table = function (_a) {
    var headers = _a.headers, rows = _a.rows, className = _a.className;
    return (React.createElement("table", { className: "Table pluggy " + (className || '') },
        React.createElement("thead", { className: 'headers-container' },
            React.createElement("tr", null, headers.map(function (header) { return (React.createElement("th", { className: 'table-header', key: header === null || header === void 0 ? void 0 : header.toString() }, header)); }))),
        rows.map(function (dataRow) { return (React.createElement("tbody", { className: 'table-row', key: dataRow.toString() }, dataRow.map(function (data, rowIndex) { return (React.createElement(React.Fragment, { key: (data === null || data === void 0 ? void 0 : data.toString()) + "_" + rowIndex },
            React.createElement("td", { className: 'table-row-data' }, data),
            React.createElement("tr", { className: 'table-row-data-mobile' },
                React.createElement("th", { className: 'table-row-header' }, headers[rowIndex]),
                React.createElement("td", { className: 'table-row-data' }, data)))); }))); })));
};
export default React.memo(Table);
